import { object, string } from 'yup';

const getValidationSchema = t => object().shape({
  email: string().email(t`Not valid email`).required(t`Mandatory`),
  password: string().required(t`Mandatory`)
});

export default getValidationSchema;